import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_8 = {
  key: 1,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_9 = {
  key: 2,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_10 = {
  key: 3,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_11 = {
  key: 4,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = {
  key: 5,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = {
  key: 1,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 2,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = {
  key: 3,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_22 = {
  key: 4,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 5,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
}
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = { class: "dropdown-menu" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 2 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 3 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 4 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_37 = {
  key: 0,
  class: "modal fade show",
  tabindex: "-1",
  style: {"display":"block"}
}
const _hoisted_38 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = { class: "modal-title" }
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "modal-footer" }
const _hoisted_45 = {
  key: 1,
  class: "modal-backdrop fade show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "mot",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher une correction"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Référence du Besc ", -1)),
                (_ctx.isAdmin || _ctx.isAgent)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_7, " Date et heure d’émission de la demande. "))
                  : _createCommentVNode("", true),
                _cache[9] || (_cache[9] = _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Date limite pour la correction ", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Message de réponse ", -1)),
                (_ctx.isAdmin || _ctx.isAgent)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_8, " Status "))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin || _ctx.isAgent)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_9, " Représentation structurée "))
                  : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Message explicatif adressé au demandeur ", -1)),
                (_ctx.isAdmin || _ctx.isAgent)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_10, " Date et heure de la réponse "))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin || _ctx.isAgent)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_11, " Référence de la tâche de validation "))
                  : _createCommentVNode("", true),
                (_ctx.isAgent)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_12, " Actions"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.corrections, (correction, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(correction.besc?.refbesc), 1),
                  (_ctx.isAdmin || _ctx.isAgent)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(_ctx.format(correction?.requested_at)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.format(correction?.due_date)), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(correction.response_message ||
                                    'Veuillez laisser un message après avoir effectué les modifications demandées'), 1),
                  (_ctx.isAdmin || _ctx.isAgent)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.getStatusBadgeClass(correction?.status)
                        }, null, 8, _hoisted_18)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isAgent)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(correction.fields_concerned), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(correction.message_to_requester), 1),
                  (_ctx.isAdmin || _ctx.isAgent)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.format(correction.responded_at) || 'Rien a signalé pour le moment'), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isAgent)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.getStatusTaskClass(correction.validationtasks?.status)
                        }, null, 8, _hoisted_23)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAgent || _ctx.isTransitaire)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", {
                            class: "badge text-white bg-primary fs-15 dropdown-toggle",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createTextVNode(" Actions "),
                            _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_26, [
                            (_ctx.isAgent)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'EditCorrectionRequestPage', params: { id: correction.id } },
                                    class: "dropdown-item d-flex align-items-center"
                                  }, {
                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                      _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode("Modifier", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isAgent)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.validerCorrection(correction))
                                  }, [...(_cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Valider la correction ", -1)
                                  ]))], 8, _hoisted_29)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isTransitaire)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.openResponseModal(correction))
                                  }, [...(_cache[14] || (_cache[14] = [
                                    _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Répondre ", -1)
                                  ]))], 8, _hoisted_31)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isTransitaire && correction.response_message)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.openEditResponseModal(correction))
                                  }, [...(_cache[15] || (_cache[15] = [
                                    _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Modifier la réponse ", -1)
                                  ]))], 8, _hoisted_33)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isAgent || _ctx.isTransitaire)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.suppression(correction.id, correction, 'correction', 'correctionRequest'))
                                  }, [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Supprimer ", -1)
                                  ]))], 8, _hoisted_35)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    (_ctx.showResponseModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("h5", _hoisted_41, _toDisplayString(_ctx.isEditMode ? 'Modifier la réponse' : 'Répondre à la demande de correction'), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showResponseModal = false))
                })
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label fw-semibold" }, " Message de réponse ", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.responseMessage) = $event)),
                    class: "form-control",
                    rows: "5",
                    placeholder: "Saisissez votre réponse..."
                  }, null, 512), [
                    [_vModelText, _ctx.responseMessage]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showResponseModal = false))
                }, " Annuler "),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitResponse && _ctx.submitResponse(...args)))
                }, _toDisplayString(_ctx.isEditMode ? 'Enregistrer les modifications' : 'Envoyer la réponse'), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showResponseModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45))
      : _createCommentVNode("", true)
  ], 64))
}